import React, { useEffect } from 'react'
import i18n from 'live/services/i18n'
import notification from 'live/services/global-notification'

const SelectedItemWithoutForm: React.FC<SelectedItemWithoutForm> = props => {
    const { onClose, event, onExport, ...rest } = props
    useEffect(() => {
        if (typeof onExport === 'function') {
            onExport(event, rest)
                .then((response: Response) => {
                    if (response.ok) notification.success(i18n('Note successfully exported'))
                    else notification.error(i18n('Note failed to be exported'))
                })
                .catch(() => {
                    notification.error(i18n('Note failed to be exported'))
                })
            onClose()
        }
    }, [event, onClose, onExport, rest])

    return null
}

export default SelectedItemWithoutForm
